import React from 'react'
import usePredictiveSearch from './use-predictive-search'
import {Loading, isEmpty} from './../../twd'
import { getSymbolSearchParams, getIssuerSearchParams, getCusipSearchParams } from './search-params'

export default ({keyword, onSearch}) => {
    const { status, error, searchResults } = usePredictiveSearch({keyword})
    const symbols = React.useMemo(() => getSymbolSearchParams(searchResults), [searchResults])
    const issuers = React.useMemo(() => getIssuerSearchParams(searchResults), [searchResults])
    const cusips = React.useMemo(() => getCusipSearchParams(searchResults, keyword), [searchResults])

    return (
    <div
        data-name="global-search-predictive-search"
        className="auto-suggest-menu"
    >
    <Loading status={status} error={error} spinner={false}>
        { !isEmpty(symbols) && "\u00A0 Symbol(s)"}
        { !isEmpty(symbols) && symbols.map( (a,i) => (
            <div key={i}
            data-name="global-search-predictive-search-symbol"
            className="auto-suggest-menu-item text-truncate"
            style={{ color:"var(--primary-base-color)" }}
            item={a}
            onClick={() => onSearch(a)}
            >{a.symbol}</div>
        ))}

        { !isEmpty(issuers) && "\u00A0 Issuer(s)"}
        { !isEmpty(issuers) && issuers.map( (a,i) => (
            <div key={i}
            data-name="global-search-predictive-search-issuer"
            className="auto-suggest-menu-item text-truncate"
            style={{ color:"var(--primary-base-color)" }}
            item={a}
            onClick={() => onSearch(a)}
            >{a.issue}</div>
        ))}

        { !isEmpty(cusips) && "\u00A0 CUSIP(s)"}
        { !isEmpty(cusips) && cusips.map( (a,i) => (
            <div key={i}
            data-name="global-search-predictive-search-cusip"
            className="auto-suggest-menu-item text-truncate"
            style={{ color:"var(--primary-base-color)" }}
            item={a}
            onClick={() => onSearch(a)}
            >{a.cusip}</div>

        ))}

    </Loading>
    </div>)
}



// WEBPACK FOOTER //
// ./src/header/global-search/predictive-search.js